import {mapValues} from 'lodash'
import {animatedPage} from '../../components/page'
import Dashboard from './dashboard' 
import MyCourses from './my-courses' 
import Catalogue from './catalogue' 
import Monitoring from './monitoring'
import Calendars from './calendars' 
import MyLessons from './my-lessons' 
import Rollbook from './rollbook'
import Quiz from './quiz'
import Grading from './grading'
import Assessment from './assessment'
import Planning from './planning'
import Resources from './resources'
import PremiumRequired from './premium-required'
import Help from './help'
import Gradebook from './gradebook'
import Homework from './homework'
import VideoGridContainer from 'components/video-grid-container'

export const teacherPages = {
  "dashboard": Dashboard,
  "my-courses": MyCourses,
  "catalogue": Catalogue,
  "monitoring": Monitoring,
  "calendars": Calendars,
  "my-lessons": MyLessons,
  "rollbook": Rollbook,
  "gradebook": Gradebook,
  "assessment": Assessment,
  "quiz": Quiz,
  "grading": Grading,
  "planning": Planning,
  "planning-rd": Planning,
  "resources": Resources,
  "premium-required": PremiumRequired,
  "homework": Homework,
  "help": Help,
  "videos": VideoGridContainer
}

const pages = mapValues(teacherPages, animatedPage)

export default pages

